import { applyDamage, hitTarget, playerDamageMult, rollDamage } from '../combat';
import { ZERO_STATS, type Monster, type Player, type Projectile, type Summon } from '../types';
import { bodyHeight, entitiesOfKind, getPlayer, type World } from '../world';

export function projectileSystem(world: World, dt: number): void {
  const player = getPlayer(world);
  for (const pr of entitiesOfKind<Projectile>(world, 'projectile')) {
    pr.pos.x += pr.vel.x * dt;
    pr.pos.y += pr.vel.y * dt;
    pr.lifetime -= dt;
    const out = pr.pos.x < -50 || pr.pos.y < -50 || pr.pos.x > world.room.width + 50 || pr.pos.y > world.room.height + 50;
    if (pr.lifetime <= 0 || out) { world.entities.delete(pr.id); continue; }
    for (const e of world.entities.values()) {
      if (!e.alive || e.team === pr.team || (e.kind !== 'monster' && e.kind !== 'player' && e.kind !== 'summon') || pr.hitIds.has(e.id)) continue;
      // Hitbox corps : capsule = segment vertical [(x, y - hauteur), (x, y)] épaissi du rayon.
      const cy = Math.min(Math.max(pr.pos.y, e.pos.y - bodyHeight(e)), e.pos.y);
      const d = Math.hypot(e.pos.x - pr.pos.x, cy - pr.pos.y);
      if (d > e.radius + pr.radius) continue;
      const target = e as Monster | Player | Summon;
      if (pr.team === 'player' && target.kind === 'monster' && player) {
        // hitTarget applique le multiplicateur de méta du joueur (playerDamageMult)
        hitTarget(world, player, target, pr.damage, { lifestealPct: pr.lifestealPct, slow: pr.slow, poison: pr.poison }, pr.pos);
      } else {
        const res = target.kind === 'monster' ? target.resistances : {};
        const mult = pr.team === 'player' && target.kind !== 'summon' ? playerDamageMult(world, target) : 1;
        applyDamage(world, target, rollDamage(world.rng, pr.damage, player?.stats ?? ZERO_STATS, res, mult), pr.damage.element, pr.pos, pr.team === 'player' ? 'player' : 'monster');
      }
      pr.hitIds.add(e.id);
      if (pr.pierce <= 0) { world.entities.delete(pr.id); break; }
      pr.pierce -= 1;
    }
  }
}
